export enum AmenityType {
  DOCCIA = 'DOCCIA',
  VASCA = 'VASCA',
}
